import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { GlobalService } from './global.service';
import { LogService } from './log.service';
import { Dupe } from '../models/dupe.model';
import { Invitation } from '../models/invitation.model';
import { InteractivityChecker } from '@angular/cdk/a11y';
import { Invite } from '../models/invite.model';
import { SubscriptionDto } from '../models/subscription-dto.model';
import { IdInfo } from '../models/id-info.model';
import { TagContentType } from '@angular/compiler';
import { Capacitor } from '@capacitor/core';
import { SwPush } from '@angular/service-worker';
import { LinkHandlerService } from './link-handler.service';

declare const WonderPush: any;

declare global {
  interface Window {

    AndroidBridge?: {
      subscribeToNotifications: () => void;
      sendTenantData: (userId, church) => void;
      downloadFile: (
        fileName: string,
        mimeType: string,
        base64: string
      ) => void;
    };

    webkit?: any;
  }
}

@Injectable({ providedIn: 'root' })

export class AppService {
  apiHost: string = environment.apiHost;

  constructor(
    private http: HttpClient,
    private logService: LogService,
    private swPush: SwPush,
    private linkHandler: LinkHandlerService
  ) {

    this.swPush.notificationClicks.subscribe(event => {
      // Access notification data and perform actions
      const notificationData = event.notification.data;
      const targetUrl = notificationData?.url; // Assuming you include a URL in your notification payload

      if (targetUrl) {
        //window.open(targetUrl, '_blank'); // Open the URL in a new tab/window
        this.linkHandler.open(targetUrl);
      }
      // You can also handle actions based on event.action
    });
  }

  getSubscription() {
    let promise = new Promise<SubscriptionDto>((resolve, reject) => {
      return this.http
        .get<SubscriptionDto>(
          this.apiHost +
          '/App/GetSubscription'
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['subscription']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Subscription', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  getAssetLinks(subdomain: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let promise = new Promise<string>((resolve, reject) => {
      return this.http
        .get<string>(
          this.apiHost +
          '/dynamicFiles/AssetLinks?subdomain=' + subdomain, { headers })
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get AssetLinks', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  getIdInfo(userId) {
    let promise = new Promise<IdInfo>((resolve, reject) => {
      return this.http
        .get<IdInfo>(
          this.apiHost +
          '/User/GetIdInfo?UserId=' + userId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get ID Info', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  sendToNative(userId, church) {

    //const platform = Capacitor.getPlatform();
    const dataToSend = {
      userId: userId,
      church: church
    };

    if (this.isAndroid() == false) { // If iOS
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.wonderPush) {
        window.webkit.messageHandlers.wonderPush.postMessage(dataToSend);
        console.warn('window.webkit.messageHandlers.wonderPush is not available.');
        // fallback
      }
    }

    else {
if (window.AndroidBridge && window.AndroidBridge.subscribeToNotifications) {

  window.AndroidBridge.sendTenantData(userId, church);
  window.AndroidBridge.subscribeToNotifications();
}
    }
  }

  async clearAllCaches(): Promise<void> {
  if ('caches' in window) {
    try {
      const cacheNames = await caches.keys();
      for (const cacheName of cacheNames) {
        // You might want to filter cache names to only delete those related to your app
        // e.g., if (cacheName.startsWith('my-app-cache-')) {
        await caches.delete(cacheName);
        // }
      }
    } catch (error) {
      console.error('Error clearing all caches:', error);
    }
  } else {
    console.warn('CacheStorage API not supported in this browser.');
  }
  }

  isAndroid(): boolean {
    return /Android/i.test(window.navigator.userAgent);
  }

downloadCsv(fileName: string, csv: string): boolean {

  const bytes = new TextEncoder().encode("\uFEFF" + csv);

  let binary = "";
  for (const b of bytes) {
    binary += String.fromCharCode(b);
  }

  const base64 = btoa(binary);

  // Android
  if (window.AndroidBridge?.downloadFile) {

    window.AndroidBridge.downloadFile(
      fileName,
      "text/csv",
      base64
    );

    return true;
  }

  // iOS
  if (window.webkit?.messageHandlers?.downloadFile) {

    window.webkit.messageHandlers.downloadFile.postMessage({
      fileName,
      mimeType: "text/csv",
      base64
    });

    return true;
  }

  return false;
}

}

